import React from 'react';

export const CardImageLoading = () => {
  return (
    <div className="vitrine-template2__card--loading" data-testid="loading">
      <div className="vitrine-template2__loading--content">
        <div className="vitrine-template2__loading--box">
          <div />
        </div>
      </div>
    </div>
  );
};
